import { DataTable } from '@frontend-platform/ui-lib';
import { useMemo } from 'react';
import { useCalibrationEnvironments } from '../hooks/use-calibration-environments';
import type { CalibrationRun } from '../lib/types';
import { buildRunListColumns } from './run-list-columns';

interface RunListTableProps {
  runs: CalibrationRun[];
  isLoading: boolean;
  isError: boolean;
  errorMessage?: string;
}

export function RunListTable({ runs, isLoading, isError, errorMessage }: RunListTableProps) {
  const { getEnvLabel } = useCalibrationEnvironments();
  const columns = useMemo(() => buildRunListColumns({ getEnvLabel }), [getEnvLabel]);

  return (
    <DataTable
      columns={columns}
      data={runs}
      getRowId={(row) => row.runId}
      isLoading={isLoading}
      defaultSorting={[{ id: 'updatedAt', desc: true }]}
      emptyState={
        isError ? (
          <span className="text-red-600 text-sm">{errorMessage || 'Failed to load runs'}</span>
        ) : (
          <span className="text-muted-foreground text-sm">No runs match your filters.</span>
        )
      }
    />
  );
}
